"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _components = require("components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var feature = (0, _glamor.css)({
  label: "feature",
  height: "42.2vw"
}, (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  height: "50vw"
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  height: "auto"
}));

var columns = (0, _glamor.css)({
  width: "100%",
  height: "100%",
  position: "relative"
}, (0, _css.minWidth)(_css.breakpoints.large)({
  display: "flex"
}));

var column = function column(order) {
  return (0, _glamor.css)({
    position: "relative"
  }, (0, _css.minWidth)(_css.breakpoints.large)({
    flexBasis: "50%",
    height: "100%",
    order: order
  }));
};

var copy = (0, _glamor.css)({
  background: "#121212",
  height: "auto",
  paddingLeft: (0, _css.unitRem)(1),
  paddingRight: (0, _css.unitRem)(1)
}, (0, _css.minWidth)(_css.breakpoints.large)({
  height: "100%"
}), (0, _polyfluid.polyfluid)({
  paddingTop: {
    small: [3, 6],
    medium: 6,
    large: 0
  },
  paddingBottom: {
    small: [4, 7.5],
    medium: 7.5,
    large: 0
  }
}));
var doubleImageText = (0, _glamor.css)({
  position: "absolute",
  zIndex: "1",
  top: "40%",
  width: "100%",
  textAlign: "center"
});

var copyInner = (0, _glamor.css)({
  maxWidth: (0, _css.unitRem)(26),
  textAlign: "center",
  margin: "auto",
  padding: 0
}, (0, _css.minWidth)(_css.breakpoints.large)(_css.center, {
  width: "100%",
  maxWidth: (0, _css.unitRem)(24),
  textAlign: "left"
}), (0, _css.minWidth)(_css.breakpoints.xlarge)({
  maxWidth: (0, _css.unitRem)(26.55)
}));

var copyTitle = (0, _glamor.css)({
  display: "block",
  color: _css.colors.white,
  fontWeight: 300
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    small: [1.75, 2.25],
    medium: 2.25,
    large: [2.25, 3]
  }
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  textAlign: "center",
  lineHeight: "37px"
}));
// const newTitle = css({
//   display: 'block',
//   color: colors.white,
//    letterSpacing: '-2.4px',
//    margin: 'auto',
//   fontWeight: 700,
// }, polyfluid({
//   fontSize: {
//     small: [2, 2.2],
//     medium: [2.2, 2.5],
//     large: [2.5, 3.75],
//   },
// }),
//   minWidth('230em')
//   ({
//     fontSize: '4.3rem'
//   })
//   ,maxWidth(breakpoints.mediumlarge)({
//   textAlign:'center',
//   lineHeight:'37px'
// }))

var copyBody = function copyBody(showWhite, newHome) {
  return (0, _glamor.css)({
    color: showWhite ? "#fff" : "#808080",
    fontWeight: newHome ? 400 : 300,
    letterSpacing: newHome && "-0.6px",
    lineHeight: 1.5
  }, (0, _css.minWidth)(_css.breakpoints.small)({
    fontWeight: newHome ? 400 : 300
  }), (0, _polyfluid.polyfluid)({
    fontSize: {
      small: newHome ? 1 : [1.25, 1.5],
      medium: newHome ? "1.3rem" : 1.125,
      large: [1.125, 1.5]
    },
    marginBottom: {
      small: 3,
      medium: 1.125,
      large: [1.125, 1.5]
    }
  }));
};

var copyLink = function copyLink(newHome) {
  return (0, _glamor.css)({
    marginTop: newHome && "2rem",
    //width:newHome && 'max-content',
    display: "block",
    fontWeight: newHome ? 600 : 300,
    textAlign: "left",
    paddingRight: (0, _css.unitRem)(1),
    paddingTop: "0",
    color: "#33a0f8",
    lineHeight: (0, _css.unitRem)(1)
  }, (0, _polyfluid.polyfluid)({
    fontSize: {
      small: newHome ? "0.9rem" : [1.25, 1.5],
      medium: newHome ? "0.9rem" : 0.9,
      large: newHome ? [0.9375, 1.125] : [1.125, 1.5]
    }
  }), (0, _css.maxWidth)(_css.breakpoints.large)({
    textAlign: "center",
    padding: 0
  }), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
    marginTop: 0
  }));
};

var image = function image(img) {
  var imgHAlign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "center";
  var backgroundSize = arguments[2];
  var show = arguments[3];
  var fade = arguments[4];
  return (0, _glamor.css)(_css.cover, (0, _css.bgCover)(img), {
    backgroundPosition: imgHAlign + " center",
    backgroundSize: backgroundSize ? "contain" : "cover",
    transition: "opacity 0.5s",
    opacity: show ? 1 : 0,
    visibility: show || fade ? "" : "hidden" // to improve performance, otherwise too many visible images with opacity 0 effect page scrolling
  });
};

var imageColumn = (0, _glamor.css)({
  height: (0, _css.unitRem)(17)
}, (0, _css.minWidth)(_css.breakpoints.large)({
  height: "100%"
}));
var titleImage = (0, _glamor.css)({
  width: (0, _css.unitRem)(2),
  height: (0, _css.unitRem)(2),
  marginRight: "1.5em"
}, (0, _css.minWidth)("230em")({
  margin: "auto",
  marginRight: "1rem"
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginBottom: 0,
  marginRight: "1rem"
}));

var hr = (0, _glamor.css)({
  width: "10rem",
  marginTop: "2.8rem",
  marginBottom: "0.8rem",
  marginLeft: "0rem",
  display: "block",
  border: "none",
  height: "2px",
  backgroundBlendMode: "normal, color",
  backgroundImage: "linear-gradient(-90deg,#2b98f0, #6497bf)"
}, (0, _css.maxWidth)(_css.breakpoints.large)({
  display: "flex",
  justifyContent: "center",
  margin: "auto",
  marginTop: "2.5rem",
  marginBottom: "1.65rem"
}));
var superHeading = (0, _glamor.css)(_fonts.superH2, {
  textTransform: "uppercase",
  display: "flex",
  justifyContent: "left",
  margin: "auto",
  //marginTop: '9.34rem',
  //paddingTop: '9rem',
  marginBottom: "1.9rem",
  //color: 'gray',
  textAlign: "center",
  maxWidth: "630px",
  color: _css.colors.gray
}, (0, _css.maxWidth)(_css.breakpoints.large)({
  display: "flex",
  justifyContent: "center"
}));
var title = (0, _glamor.css)(_fonts.H3, {
  textTransform: "uppercase",
  display: "block",
  color: _css.colors.white,
  margin: "auto"
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  textAlign: "center"
}));
var description = (0, _glamor.css)(_fonts.p1, {
  color: "#808080"
}, (0, _polyfluid.polyfluid)({
  marginBottom: {
    small: 3,
    medium: 4,
    large: [4]
  }
}));
var links = (0, _glamor.css)(_fonts.textBtn1, {
  textTransform: "uppercase",
  "& a": {
    padding: 0,
    textTransform: "uppercase"
  },
  "& button": {
    padding: 0,
    textTransform: "uppercase"
  },
  display: "block",
  textAlign: "left",
  paddingRight: (0, _css.unitRem)(1),
  paddingTop: "0",
  color: "#33a0f8"
}, (0, _polyfluid.polyfluid)({}), (0, _css.maxWidth)(_css.breakpoints.large)({
  textAlign: "center",
  padding: 0,
  margin: "auto",
  marginTop: "2em"
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginTop: 0
}));

var titleImageContainer = (0, _glamor.css)({
  width: "100%",
  textAlign: "left",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, (0, _polyfluid.polyfluid)({
  marginBottom: {
    small: [1.7, 2],
    medium: 1.25,
    large: [1.25, 1.5]
  }
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  flexDirection: "column"
}), (0, _css.minWidth)(_css.breakpoints.large)({
  justifyContent: "initial"
}));

var artist = function artist(flip, show) {
  return (0, _glamor.css)(_fonts.p4, {
    position: "absolute",
    right: flip ? "auto" : (0, _css.unitRem)(1.33),
    left: flip ? (0, _css.unitRem)(1.33) : "auto",
    bottom: (0, _css.unitRem)(1.33),
    textTransform: "uppercase",
    transition: "opacity 0.5s",
    opacity: show ? 1 : 0
  });
};
var footer = function footer(footerPostsition) {
  return (0, _glamor.css)({
    display: "block",
    right: !footerPostsition || footerPostsition != "left" ? (0, _css.unitRem)(1.33) : "",
    left: footerPostsition && footerPostsition == "left" ? (0, _css.unitRem)(1.33) : "",
    bottom: (0, _css.unitRem)(1.33),

    position: "absolute",

    fontSize: (0, _css.unitRem)(0.5),
    textTransform: "uppercase"
  }, (0, _css.maxWidth)(_css.breakpoints.large)({
    position: "relative",
    textAlign: "center",
    marginTop: 26,
    top: 0,
    left: 0
  }));
};

var Feature = function (_React$Component) {
  (0, _inherits3.default)(Feature, _React$Component);

  function Feature(props) {
    (0, _classCallCheck3.default)(this, Feature);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Feature.__proto__ || (0, _getPrototypeOf2.default)(Feature)).call(this, props));

    _this.state = {
      displayIndex: 0
    };
    return _this;
  }

  (0, _createClass3.default)(Feature, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var props = this.props;
      if (props.images && props.images.length > 1) {
        this.loadedImages = [];

        var _loop = function _loop(i) {
          var im = new Image();
          var index = i;
          im.onload = function () {
            _this2.loadedImages[index] = true;
          };
          im.src = props.images[i];
        };

        for (var i = 0; i < props.images.length; i++) {
          _loop(i);
        }
        this.interval = setInterval(function () {
          var newIndex = _this2.state.displayIndex + 1;

          if (newIndex >= props.images.length) {
            newIndex = 0;
          }
          if (_this2.loadedImages[newIndex]) {
            var previousIndex = _this2.state.displayIndex; //this should also be faded and shown
            _this2.setState({ displayIndex: newIndex, previousIndex: previousIndex });
          }
        }, 2000);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.props;
      var images = props.images && props.images.length ? props.images : [props.img];
      var artists = props.artists && props.artists.length ? props.artists : !!props.artist ? [props.artist] : null;
      return _react2.default.createElement(
        "section",
        feature,
        _react2.default.createElement(
          "div",
          { className: columns },
          !props.img2 && _react2.default.createElement(
            "div",
            { className: column(props.flip ? 2 : 1) },
            _react2.default.createElement(
              "div",
              copy,
              _react2.default.createElement(
                "div",
                copyInner,
                _react2.default.createElement(
                  "div",
                  { className: titleImageContainer },
                  props.titleIcon ? props.newHome ? [_react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                      "div",
                      { className: superHeading },
                      "QUIXEL"
                    ),
                    _react2.default.createElement("br", null),
                    _react2.default.createElement(
                      "div",
                      { className: (0, _glamor.css)({ display: "flex" }) },
                      _react2.default.createElement("img", {
                        alt: "",
                        key: "1",
                        src: props.titleIcon,
                        className: titleImage
                      }),
                      _react2.default.createElement("h1", {
                        key: "2",
                        className: title,
                        dangerouslySetInnerHTML: {
                          __html: props.title
                        }
                      })
                    ),
                    _react2.default.createElement("br", null),
                    _react2.default.createElement("hr", { className: hr })
                  )] : [_react2.default.createElement("img", {
                    alt: "",
                    key: "1",
                    src: props.titleIcon,
                    className: titleImage
                  }), _react2.default.createElement("h1", {
                    key: "2",
                    className: copyTitle,
                    dangerouslySetInnerHTML: {
                      __html: props.title
                    }
                  })] : props.newHome ? _react2.default.createElement(
                    "div",
                    null,
                    props.featureType ? _react2.default.createElement(
                      "div",
                      { className: superHeading },
                      props.featureType
                    ) : _react2.default.createElement(
                      "div",
                      { className: superHeading },
                      "QUIXEL"
                    ),
                    _react2.default.createElement("h1", {
                      className: title,
                      dangerouslySetInnerHTML: {
                        __html: props.title
                      }
                    }),
                    _react2.default.createElement("hr", { className: hr })
                  ) : _react2.default.createElement("h1", {
                    className: copyTitle,
                    dangerouslySetInnerHTML: {
                      __html: props.title
                    }
                  })
                ),
                _react2.default.createElement(
                  "p",
                  description,
                  props.desc
                ),
                _react2.default.createElement(
                  "div",
                  {
                    className: (0, _glamor.css)({ display: "flex" }, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
                      justifyContent: "center"
                    }))
                  },
                  props.link && props.link.map(function (item, index) {
                    return _react2.default.createElement(
                      _components.TextButtonLibrary,
                      (0, _extends3.default)({
                        key: index
                      }, item, {
                        mode: "small",
                        className: links
                      }),
                      item.label
                    );
                  })
                )
              ),
              props.footer && _react2.default.createElement(
                "span",
                { className: footer(props.footerPosition) },
                props.footer
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: column(1) },
            _react2.default.createElement(
              "div",
              imageColumn,
              images.map(function (img, index) {
                return _react2.default.createElement("span", (0, _extends3.default)({
                  key: index
                }, image(img, props.imgHAlign, props.backgroundSize, index == _this3.state.displayIndex, index == _this3.state.previousIndex)));
              }),
              artists && artists.map(function (art, index) {
                return _react2.default.createElement(
                  "div",
                  {
                    key: index,
                    className: artist(props.flip, index == _this3.state.displayIndex)
                  },
                  art
                );
              })
            )
          )
        )
      );
    }
  }]);
  return Feature;
}(_react2.default.Component);

exports.default = Feature;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/Feature.jsx
// module id = 2865
// module chunks = 0